import { render, staticRenderFns } from "./Deficientes.vue?vue&type=template&id=75edeefe"
import script from "./Deficientes.vue?vue&type=script&lang=js"
export * from "./Deficientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports